export default __webpack_public_path__ + "static/media/close.d72d4394.svg";